import { FC, ReactNode, useState } from 'react'

import { PopoverProps, Popover } from 'antd'
import styled from 'styled-components'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

import { SortingButton } from './SortingButton'

export interface SortingProps {
  disabled?: boolean
  text?: string
  renderContent: (onHide: () => void) => ReactNode
}

const StyledPopover = styled((props: PopoverProps) => (
  <Popover {...props} classNames={{ root: props.className }} />
))`
  .ant-popover-content {
    right: 16px;
    @media (min-width: ${MAX_MOBILE_WIDTH}) {
      right: 7px;
    }
  }
  .ant-popover-inner {
    padding: 0;
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme.color.lightGrey};
    background: ${({ theme }) => theme.color.white};
    box-shadow: ${({ theme }) => theme.shadow.header};
  }
`

export const Sorting: FC<SortingProps> = (props) => {
  const { disabled, text, renderContent } = props
  const [open, setOpen] = useState(false)
  const hide = (): void => {
    setOpen(false)
  }

  const handleOpenChange = (newOpen: boolean): void => {
    setOpen(newOpen)
  }
  const content = renderContent(hide)
  return (
    <StyledPopover
      content={content}
      trigger='click'
      placement='bottom'
      arrow={false}
      open={open}
      onOpenChange={handleOpenChange}
    >
      <SortingButton text={text} disabled={disabled} />
    </StyledPopover>
  )
}
